<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <section class="bg-slate-900 py-20" aria-labelledby="about-mission-title">
    <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <p class="text-emerald-400 font-semibold text-sm uppercase tracking-widest">
        {{ t('about.mission.eyebrow') }}
      </p>
      <h2 id="about-mission-title" class="mt-4 text-3xl md:text-5xl font-black text-white leading-tight text-balance">
        {{ t('about.mission.before') }}<span class="text-emerald-400">{{ t('about.mission.highlight') }}</span>{{ t('about.mission.after') }}
      </h2>
    </div>
  </section>
</template>
